<template>
  <page-view :title="false">
    <a-card :bordered="false" v-show="!order.visible">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
			  <a-col :md="8" :sm="24">
				<a-form-item label="流水号"
				  ><a-input
					v-model="queryParam.mcNo"
					placeholder="流水号"
				/></a-form-item>
			  </a-col>
			  <a-col :md="8" :sm="24">
			    <a-form-item label="标识">
			      <a-select
			        v-model="queryParam.mcType"
			        placeholder="请选择"
			        allowClear
			      >
			        <a-select-option value="PA">消费产生合同</a-select-option>
			        <a-select-option value="AP">合同调整-产生合同</a-select-option>
			        <a-select-option value="AC">合同调整-使用合同</a-select-option>
			        <a-select-option value="CH">合同使用</a-select-option>
                    <a-select-option value="IN">合同失效</a-select-option>
			  					<!-- <a-select-option value="PR">产生合同撤销</a-select-option>
			  					<a-select-option value="PE">兑换合同撤销</a-select-option>
			  					<a-select-option value="PP">合同奖励</a-select-option>
			  					<a-select-option value="PC">合同录入</a-select-option>
			  					<a-select-option value="LT">合同转出</a-select-option>
			  					<a-select-option value="LF">合同转入</a-select-option> -->
			      </a-select>
			    </a-form-item>
			  </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="订单号"
                  ><a-input v-model="queryParam.orderNo" placeholder="订单号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="I">有效</a-select-option>
                    <a-select-option value="X">失效</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button class="button-margin-left" @click="rest"
                  >重置</a-button
                >
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 1860 }"
        showPagination="auto"
      >
	  
	  <span slot="tagItem" slot-scope="text, record">
	    <template>
	      <a-tag
	        class="render-tag"
	        color="#19be6b"
	        v-if="record.sta == 'I'"
	        >有效</a-tag
	      >
	      <a-tag
	        class="render-tag"
	        color="#ed4014"
	        v-if="record.sta == 'X'"
	        >失效</a-tag
	      >
	    </template>
	  </span>
	  <span slot="tagTypeItem" slot-scope="text, record">
	    <template>
	      <span v-if="record.mcType == 'PA'">[PA]消费产生合同</span>
	      <span v-if="record.mcType == 'PR'">[PR]产生合同撤销</span>
		  <span v-if="record.mcType == 'CH'">[CH]使用合同</span>
		  <span v-if="record.mcType == 'PE'">[PE]兑换合同撤销</span>
		  <span v-if="record.mcType == 'IN'">[IN]合同失效</span>
		  <span v-if="record.mcType == 'PP'">[PP]合同奖励</span>
		  <span v-if="record.mcType == 'PC'">[PC]合同录入</span>
		  <span v-if="record.mcType == 'LT'">[LT]合同转出</span>
		  <span v-if="record.mcType == 'LF'">[LF]合同转入</span>
		  <span v-if="record.mcType == 'AP'">[AP]合同调整-产生合同</span>
		  <span v-if="record.mcType == 'AC'">[AC]合同调整-使用合同</span>
	    </template>
	  </span>
	  <span slot="produceItem" slot-scope="text">
		<template>
			<span :style="{color: text!=0?'#19be6b':'#dcdee2'}">{{text}}</span>
		</template>
	  </span>
	  <span slot="applyItem" slot-scope="text">
		<template>
			<span :style="{color: text!=0?'red':'#dcdee2'}">{{text}}</span>
		</template>
	  </span>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";

export default {
  name: "ContractList",
  components: {
    STable,
    PageView
  },
  data() {
    return {
      userInfo: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
		  sort: "number:desc"
	  },
      // 表头
      columns: [
        {
          title: "流水号",
          dataIndex: "mcNo",
          fixed: "left"
        },
        {
          title: "标识",
          dataIndex: "mcType",
		  scopedSlots: { customRender: "tagTypeItem" },
          width: 180
        },
        {
          title: "状态",
          dataIndex: "sta",
		  scopedSlots: { customRender: "tagItem" },
          width: 80
        },
        {
          title: "序号",
          dataIndex: "number",
          width: 80
        },
        {
          title: "产生合同",
          dataIndex: "produce",
		  scopedSlots: { customRender: "produceItem" },
          width: 120
        },
		{
		  title: "使用合同",
		  dataIndex: "apply",
		  scopedSlots: { customRender: "applyItem" },
		  width: 120
		},
		{
		  title: "合同余量",
		  dataIndex: "balance",
		  width: 120
		},
        {
          title: "订单号",
          dataIndex: "orderNo",
          width: 240
        },
		{
		  title: "产生日期",
		  dataIndex: "mcGenDate",
		  width: 180
		},
		{
		  title: "失效日期",
		  dataIndex: "invalidDate",
		  width: 180
		},
        {
          title: "备注",
          dataIndex: "remark",
          width: 300,
          ellipsis: true
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageMerchantContract(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      },
      order: {
        info: {},
        visible: false
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.queryParam.merchantNo = this.userInfo.merchantNo;
  },
  methods: {
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    rest() {
      this.queryParam = {};
      this.queryParam.merchantNo = this.userInfo.merchantNo;
	  this.queryParam.sort = "number:desc";
    }
  }
};
</script>
